<template>
    <div class="renjie hml_whplt">
        <swiperList :swiperStyle="{padding: '.92rem 0 0rem'}" :setSwiperNumFlag="true">
            <img :src="RJBG">
            <div class="ContentList">
                <li
                class="renjieSlide"
                v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
                :key="index"
                @click="ruralSlideClick(index)"
                >
                    <img :src="item.thumb">
                    <div class="labelAndTitle">
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.keywords }}</p>
                        
                    </div>
                    <!-- <h2>{{ item.title }}</h2> -->
                    <!-- <img :src="item.thumb">
                    <div class="textContent">
                        <div class="titleBox">
                            <h2 class="title">{{ item.title }}</h2>
                            <ul class="list">
                                <li
                                v-for="(value,ind) in item.keywords.split('|')"
                                :key="ind"
                                >
                                    {{ value }}
                                </li>
                            </ul>
                        </div>
                        <div class="xian"></div>
                        <p>{{ item.description }}</p>
                    </div> -->
                </li>
            </div>
            
        </swiperList>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {

        }
    },
    methods: {
        ruralSlideClick(index){
            this.setIndex({levelThreeIndex: index});
            this.$router.push("/foodDetails");
        },
        ...publicData.mapMutations(["setIndex"])
    },
    computed: {
        ...publicData.mapState(['allData','firstLevelIndex','secondLevelIndex','levelThreeIndex'])
    }
}
</script>

<style lang="scss" scoped>
.renjie{
    .ContentList{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
    }
    .renjieSlide{
        width: 2.5rem;
        height: 2.46rem;
        position: relative;
        img{
            width: 2.5rem;
            height: 2.43rem;
        }
        .labelAndTitle{
            width: 2.07rem;
            height: 1.05rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -.5rem;
            background: url(../../../assets/img/secondLevelPage/labelAndTitleBg.png) no-repeat;
            background-size: 100% 100%;
            h3{
                color: #fff;
                font-size: .32rem;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: .12rem;
                white-space: nowrap;
                font-family: "siyuan";
                font-weight: bold;
            }
            p{
                color: #666;
                font-size: .22rem;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: .20rem;
                white-space: nowrap;
                // font-family: "siyuan";
            }
        }
        h2{
            width: 2rem;
            height: .73rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            background: url(../../../assets/img/secondLevelPage/renjieTextBg.png) no-repeat;
            background-size: 100% 100%;
            font-size: .3rem;
            color: #333;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        &:nth-child(1){
            margin-top: 1.4rem;
            margin-left: 1.3rem;
        }
        &:nth-child(2){
            margin-left: 4.5rem;
            margin-top: -1rem;
        }
        &:nth-child(3){
            margin-left: 1.5rem;
        }
        &:nth-child(4){
            margin-left: 4.2rem;
            margin-top: .5rem;
        }
        &:nth-child(5){
            margin-top: 0rem;
            margin-left: 1rem;
        }
        &:nth-child(6){
            margin-left: 0rem;
            margin-top: .5rem;
        }
        &:nth-child(7){
            margin-left: 3.5rem;
            margin-top: -.6rem;
        }
        &:nth-child(8){
            margin-left: 1.2rem;
            margin-top: .3rem;
        }
        &:nth-child(9){
            margin-top: .5rem;
            margin-left: 3.5rem;
        }
        &:nth-child(10){
            margin-left: 1rem;
            margin-top: 0rem;
        }
        &:nth-child(11){
            margin-top: .5rem;
            margin-left: 0.5rem;
        }
        &:nth-child(12){
            margin-left: 4rem;
            margin-top: 0rem;
        }
        &:nth-child(13){
            margin-left: 1rem;
            margin-top: 0rem;
        }
        &:nth-child(14){
            margin-left: 4rem;
            margin-top: .5rem;
        }
    }
    // padding-top: .92rem;
    /* .renjieSlide{
        width: 6.7rem;
        height: 2.2rem;
        position: relative;
        overflow: hidden;
        box-shadow:0px .13rem .27rem 0px rgba(0, 0, 0, 0.24);
        display: flex;
        align-items: center;
        background: #fff;
        margin-bottom: .48rem;
        img{
            width: 2.2rem;
            height: 100%;
        }
        .textContent{
            width: 4.3rem;
            margin-left: .2rem;
            .titleBox{
                display: flex;
                align-items: center;
                h2{
                    color: #333;
                    font-size: .4rem;
                    font-weight: bold;
                    font-family: "siyuan";
                }
                .list{
                    display: flex;
                    align-items: center;
                    margin-left: .26rem;
                    li{
                        color: #333;
                        font-size: .26rem;
                    }
                }
                span{
                    color: #333;
                    font-size: .26rem;
                }
            }
            .xian{
                width: 4.04rem;
                height: .02rem;
                background: #000;
                margin: .2rem 0 .26rem;
            }
            p{
                color: #999;
                font-size: .22rem;
                line-height: .3rem;
            }
        }
    } */
}
</style>